module.exports = __webpack_public_path__ + "static/media/image-banner-2.8de407ea.svg";